import { Box, Typography, useMediaQuery, useTheme } from "@mui/material";
import hero from "../../assets/hero-homepage.jpeg";
import { useTranslation } from "react-i18next";

const Homepage = () => {
  const { t } = useTranslation();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  return (
    <Box sx={{ paddingBottom: 5 }}>
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          backgroundImage: `url(${hero})`,
          backgroundRepeat: "no-repeat",
          backgroundSize: "cover",
          backgroundPosition: "center",
          height: "500px",
          width: "100%",
        }}
      >
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            backgroundColor: "#432775b5",
            marginTop: "auto",
            marginBottom: "auto",
            flexDirection: "column",
            height: "50%",
            paddingX: isMobile ? 2 : 10,
          }}
        >
          <Typography sx={{ color: "#fff" }} variant="h2" textAlign="center">
            {t("homepage.welcome")}
          </Typography>
          <Typography
            sx={{
              color: "#eee",
              fontSize: isMobile ? "16px" : "24px",
              textTransform: "capitalize",
              margin: 0,
              textAlign: "center",
            }}
          >
            “Harvesting (digital) Alternation in Ways
          </Typography>
          <Typography
            sx={{
              color: "#eee",
              fontSize: isMobile ? "16px" : "24px",
              margin: 0,
              textAlign: "center",
            }}
          >
            that Knock-down Inaccessibility of New Generations“
          </Typography>
        </Box>
      </Box>

      <Box sx={{ marginTop: 6 }}>
        <Typography
          sx={{
            textAlign: "center",
            fontSize: "26px",
            color: "#333",
            fontWeight: "bold",
            textTransform: "uppercase",
            marginBottom: 5,
          }}
          variant="h3"
        >
          {t("homepage.about_project")}
        </Typography>

        <Box className="sections" sx={{ paddingX: isMobile ? 2 : 35 }}>
          <Typography sx={{ fontSize: "15px", color: "#555", textAlign: "justify" }}>
            <span style={{ fontWeight: "bold" }}>{t("project_title")}</span>{" "}
            {t("homepage.first_parag")}
          </Typography>
          <br />
          <Typography
            sx={{ fontSize: "15px", color: "#555", textAlign: "justify", marginBottom: "30px" }}
          >
            {t("homepage.second_parag")}
          </Typography>

          <Box
            sx={{
              display: "flex",
              flexDirection: isMobile ? "column" : "row",
              justifyContent: "center",
            }}
          >
            <Box
              sx={{
                width: isMobile ? "100%" : "50%",
                marginRight: isMobile ? 0 : 2,
                marginBottom: 4,
              }}
            >
              <Typography
                sx={{ color: "#444", fontSize: "24px", fontWeight: "600", marginBottom: 2 }}
              >
                {t("homepage.goal")}
              </Typography>
              <Typography sx={{ fontSize: "15px", color: "#555" }}>
                {t("homepage.goal_parag")}
              </Typography>
            </Box>
            <Box sx={{ width: isMobile ? "100%" : "50%" }}>
              <Typography
                sx={{ color: "#444", fontSize: "24px", fontWeight: "600", marginBottom: 2 }}
              >
                {t("homepage.target_group")}
              </Typography>
              <Typography sx={{ fontSize: "15px", color: "#555" }}>
                {t("homepage.target_group_parag")}
              </Typography>
            </Box>
          </Box>

          <Box
            sx={{
              display: "flex",
              flexDirection: isMobile ? "column" : "row",
              justifyContent: "center",
              marginTop: isMobile ? 2 : 0,
            }}
          >
            <Box
              sx={{
                width: isMobile ? "100%" : "50%",
                marginRight: isMobile ? 0 : 2,
                marginBottom: isMobile ? 2 : 0,
              }}
            >
              <Typography
                sx={{ color: "#444", fontSize: "24px", fontWeight: "600", marginBottom: 2 }}
              >
                {t("homepage.coordinator")}
              </Typography>
              <Typography sx={{ fontSize: "15px", color: "#555" }}>{t("ucg")}</Typography>
            </Box>
            <Box sx={{ width: isMobile ? "100%" : "50%" }}>
              <Typography
                sx={{ color: "#444", fontSize: "24px", fontWeight: "600", marginBottom: 2 }}
              >
                {t("homepage.participators")}
              </Typography>
              <Typography sx={{ fontSize: "15px", color: "#555" }}>
                {t("homepage.participators_parag")}
              </Typography>
            </Box>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default Homepage;
